import { createSelector } from 'reselect';

import {
  hasCustomerInActiveSessionMessages,
  formHasEmailQuestion,
  getCompanyShowEmailInputBanner,
} from '../../../app/ChatApp/selectors';

export const getShow = state => state.getIn(['chat', 'describe', 'show'], false);
export const getEmailSuccess = state => state.getIn(['chat', 'describe', 'email', 'success'], false);

export const getEmailAddress = state => state.getIn(['chat', 'describe', 'email', 'address'], false);

export const getShowForCurrentConversation = createSelector(
  [getShow, hasCustomerInActiveSessionMessages, formHasEmailQuestion, getCompanyShowEmailInputBanner],
  (show, hasCustomer, formHasEmailQ, showEmailInputBanner) => {
    return show && showEmailInputBanner && hasCustomer && !formHasEmailQ;
  },
);
